export const saveToken = (token) => {
    if(localStorage.getItem("allowCookies")) localStorage.setItem("token", token)
}
export const getToken = () => {
    return localStorage.getItem("token")
}